module.exports = __webpack_public_path__ + "static/media/rose2.e8e69937.svg";